import { render, staticRenderFns } from "./ProfileSettings.vue?vue&type=template&id=527687f4&scoped=true&"
import script from "./ProfileSettings.vue?vue&type=script&lang=js&"
export * from "./ProfileSettings.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSettings.vue?vue&type=style&index=0&id=527687f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527687f4",
  null
  
)

export default component.exports